import { render, staticRenderFns } from "./MinhaEquipe.vue?vue&type=template&id=081b3ff4&scoped=true&lang=pug&"
import script from "./MinhaEquipe.vue?vue&type=script&lang=js&"
export * from "./MinhaEquipe.vue?vue&type=script&lang=js&"
import style0 from "./MinhaEquipe.vue?vue&type=style&index=0&id=081b3ff4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081b3ff4",
  null
  
)

export default component.exports